import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { LionTranslate, lionSelectors } from '@rosetta/react-lion';
import { appActions, appSelectors, TRANSACTION_STATE } from '../../app/reducer/app-reducer';
import {
  appMainBackground,
  appTextColor,
  confirmationGreen,
  dashboardGoalsBackground,
  defaultBoxShadow,
  lightGrey,
  lightBlueColor,
  warningRedColor,
  white
} from '../../../styles/colors';
import userIcon from '../../../assets/images/user-icon.svg';
import { menuStyle } from '../../../styles/LaunchpadCompactDropdownStyle';
import { LaunchpadButton } from '../../../styles/LaunchpadButton';
import { RSDropdown } from '@rosetta/rs-dropdown';
import { MouseCatcherContainer as MouseCatcher } from '../../app/util/MouseCatcher';
import { passwordChangeActions, passwordChangeSelectors } from '../../login/reducer/password-change-reducer';
import { preferencesActions, preferencesSelectors } from '../reducer/preferences-reducer';
import { InputWithIconContainer as InputWithIcon } from '../../app/util/InputWithIcon';
import greenCheck from '../../../assets/images/check-solid-green.svg';
import arrowDown from '../../../assets/images/arrow-down-grey-solid.svg';
import helpIcon from '../../../assets/images/help-icon.svg';
import { timezones, validateUserInfo, voiceTypes } from '../../app/util/user-helper';
import { getLearnerSelectLearningLanguages } from '../../app/services/language-helpers';
import { HelpButtonContainer as HelpButton } from '../../app/util/HelpButton';
import { authSelectors } from '@rosetta/react-auth';
import { InputAndAlertContainerContainer as InputAndAlertContainer } from '../../app/util/InputAndAlertContainer';
import { LinkButton } from '../../../styles/LinkButton';
import { LOGIN_STATUS } from '@rosetta/react-auth/dist/index';
import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';
import { catalystProductId, foundationProductId } from '../../../helpers/productConfigHelper';

let isRtl = false;

const widgetWidth = 240;
const widgetWidthMobile = 300;
const widgetHeight = 34;
const boxSidePadding = 0;

const PreferencesDiv = styled.div((props) => {
  let style = {
    position: !props.isMobile ? 'absolute' : 'relative',
    top: '0px',
    bottom: '0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: appMainBackground
  };
  return style;
});

const PreferencesBox = styled.div((props) => {
  let style = {
    backgroundColor: !props.isMobile ? white : appMainBackground,
    paddingTop: !props.isMobile ? 30 : 0,
    paddingBottom: !props.isMobile ? 30 : 0,
    width: '100%',
    maxWidth: !props.isMobile ? 600 : '100%',
    boxShadow: !props.isMobile ? defaultBoxShadow : 'none',
    borderRadius: '4px'
  };
  return style;
});

const TopContainer = styled.div((props) => {
  let style = {
    display: !props.isMobile ? 'flex' : 'block',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: !props.isMobile ? '0 30px 0px' : '0 10px 10px',
    width: '100%'
  };

  if (!props.isMobile) {
    style.display = 'block';
    style.flexDirection = 'row';
    style.justifyContent = 'space-between';
  }
  return style;
});

const MiddleContainer = styled.div((props) => {
  let style = {
    display: !props.isMobile ? 'flex' : 'block',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: !props.isMobile ? '0 30px 30px' : '0 10px 10px',
    width: '100%'
  };

  if (!props.isMobile) {
    style.display = 'flex';
    style.flexDirection = 'row';
    style.justifyContent = 'space-between';
  }
  return style;
});

const BottomContainer = styled.div((props) => {
  let style = {};
  if (!props.isMobile) {
    style.justifyContent = 'space-between';
    style.width = '100%';
    style.margin = 'auto';
  } else {
    style.margin = '0 16px';
  }
  return style;
});

const LeftColumn = styled.div((props) => {
  let style = {
    marginRight: !props.isMobile ? 35 : 0,
    marginBottom: !props.isMobile ? 0 : 40
  };
  if (!props.isMobile) {
    style.width = widgetWidth;
  }
  return style;
});

const RightColumn = styled.div((props) => {
  let style = {};
  if (!props.isMobile) {
    style.width = widgetWidth;
  }
  return style;
});

const UserName = styled.div((props) => {
  let style = {
    width: '100%',
    fontSize: !props.isMobile ? '32px' : '18px',
    fontWeight: '300',
    lineHeight: '36px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: '15px',
    color: !props.isMobile ? appTextColor : white,
    textAlign: !props.isMobile ? 'left' : 'center',
    paddingTop: !props.isMobile ? '0' : '105px',
    paddingBottom: !props.isMobile ? '0' : '12px',
    backgroundColor: !props.isMobile ? white : dashboardGoalsBackground
  };

  if (props.isMobile) {
    style.backgroundImage = 'url(' + userIcon + ')';
    style.backgroundRepeat = 'no-repeat';
    style.backgroundSize = '80px 80px';
    style.backgroundPosition = 'center 14px';
  }
  return style;
});

const UserEmail = styled.div((props) => {
  let style = {
    width: '100%',
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '18px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginTop: '10px',
    marginBottom: '10px',
    color: appTextColor
  };
  if (props.isMobile) {
    style.display = 'none';
  }
  return style;
});

const FieldLabel = styled.div(() => {
  let style = {
    display: 'inline-block',
    fontSize: '14px',
    lineHeight: '15px',
    textAlign: 'left',
    fontWeight: 'bold',
    marginTop: '0px',
    marginBottom: '5px',
    color: appTextColor,
    verticalAlign: 'top'
  };
  return style;
});

const FieldErrorDisp = styled.div(() => {
  let style = {
    display: 'block',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 'normal',
    color: warningRedColor,
    marginBottom: '5px'
  };
  if (isRtl) {
    style.textAlign = 'right';
  } else {
    style.textAlign = 'left';
  }
  return style;
});

const MenuContainer = styled.div((props) => {
  let style = {
    display: 'block',
    height: widgetHeight,
    width: '100%',
    marginBottom: props.marginBottom ? props.marginBottom : 15
  };
  if (props.marginTop) {
    style.marginTop = props.marginTop;
  }
  return style;
});

const SaveChangesButton = styled(LaunchpadButton)((props) => {
  let style = {
    float: !props.isMobile ? 'right' : 'none',
    margin: !props.isMobile ? '0 18px' : '0px',
    width: !props.isMobile ? '200px' : '100%',
    fontSize: '16px',
    display: 'inline-flex',
    textAlign: 'center'
  };
  if (props.isMobile) {
    style.borderRadius = '4px';
  }
  return style;
});

const CancelChangesButton = styled(LaunchpadButton)((props) => {
  let style = {
    backgroundColor: !props.isMobile ? white : appMainBackground,
    color: lightBlueColor,
    float: !props.isMobile ? 'right' : 'none',
    fontSize: '16px',
    ':hover': {
      textDecoration: 'underline',
      backgroundColor: !props.isMobile ? white : appMainBackground
    },
    width: !props.isMobile ? '120px' : '100%'
  };
  return style;
});

const ErrorDisp = styled.div((props) => {
  let style = {
    backgroundColor: warningRedColor,
    color: white,
    fontSize: '12px',
    lineHeight: '18px',
    width: !props.isMobile ? '100%' : widgetWidthMobile,
    margin: !props.isMobile ? '0px' : 'auto',
    marginTop: !props.isMobile ? '-30px' : '0px',
    padding: '6px 12px'
  };
  return style;
});

const PasswordUpdateLink = styled(LinkButton)((props) => {
  return {
    float: 'left',
    paddingTop: '10px'
  };
});

const PasswordInputContainer = styled.div({
  fontSize: '14px',
  paddingTop: 16,
  paddingBottom: 15
});

const ValidationMessage = styled.div(() => {
  let style = {
    color: warningRedColor,
    fontSize: '12px',
    minHeight: '1px',
    marginBottom: 7,
    marginTop: 13,
    marginLeft: boxSidePadding,
    marginRight: boxSidePadding
  };
  return style;
});

const PasswordPromptLabel = styled.div({
  fontSize: '11px',
  lineHeight: '15px',
  fontWeight: 'bold',
  paddingBottom: '6px'
});

const SuccessDisp = styled.div((props) => {
  let style = {
    backgroundColor: confirmationGreen,
    backgroundImage: 'url(' + greenCheck + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: !props.isMobile ? '4% 78%' : '6% 78%',
    backgroundPositionX: '5px',
    backgroundPositionY: '2px',
    color: white,
    fontSize: '12px',
    lineHeight: '18px',
    width: !props.isMobile ? '100%' : widgetWidthMobile,
    margin: !props.isMobile ? '0px' : 'auto',
    marginTop: !props.isMobile ? '-30px' : '0px',
    padding: '6px 12px'
  };
  return style;
});

const PasswordToolTip = styled.div({
  float: 'right'
});

const SuccessMessage = styled.div({
  marginLeft: '22px'
});

const DisabledHelpButton = styled.div(() => {
  let style = {
    backgroundImage: 'url(' + helpIcon + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    display: 'inline-block',
    height: '12px',
    marginTop: '3px',
    opacity: '0.3',
    verticalAlign: 'top',
    width: '12px'
  };
  if (isRtl) {
    style.marginRight = '8px';
  } else {
    style.marginLeft = '8px';
  }
  return style;
});

const DisabledMenuButton = styled(LaunchpadButton)((props) => {
  let style = {
    backgroundColor: white,
    border: '1px solid ' + lightGrey,
    borderRadius: '4px',
    display: 'block',
    height: widgetHeight,
    marginBottom: props.marginBottom ? props.marginBottom : '12px',
    textAlign: 'left',
    width: '100%'
  };
  return style;
});

const DisabledMenuButtonLabel = styled.div(() => {
  let style = {
    color: lightGrey,
    fontSize: '12px',
    fontWeight: '400',
    height: '100%',
    letterSpacing: '0.7px',
    lineHeight: '15px',
    marginTop: '8.5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
  if (isRtl) {
    style.marginLeft = '31px';
    style.marginRight = '16px';
  } else {
    style.marginLeft = '16px';
    style.marginRight = '31px';
  }
  return style;
});

const DisabledMenuButtonArrow = styled.div(() => {
  let style = {
    backgroundImage: 'url(' + arrowDown + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    float: 'right',
    height: '15px',
    marginTop: '8px',
    opacity: '0.3',
    width: '15px'
  };
  if (isRtl) {
    style.marginLeft = '16px';
  } else {
    style.marginRight = '16px';
  }
  return style;
});

const ChangeLanguageLink = styled(LinkButton)((props) => {
  return {
    float: 'left'
  };
});

const passwordUpdateInitialState = {
  oldPassword: '',
  password: '',
  passwordConfirm: '',
  showPasswordUpdateFields: false,
  validatingOldPassword: false,
  validatingPassword: false,
  validatingPasswordMatch: false
};

//*********************************************
export class Preferences extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      password: '',
      passwordConfirm: '',
      selectedLearningLanguage: '',
      validatingOldPassword: false,
      validatingPassword: false,
      validatingPasswordMatch: false,
      selectedVoiceType: '',
      selectedTimezone: '',
      showPasswordUpdateFields: false,
      showSaveChangesConfirmation: false,
      isLoadingPasswordMode: false
    };

    props.getLearnerCanChangeL2();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isAppInitialized && nextProps.loginStatus !== LOGIN_STATUS.LOGGED_IN) {
      nextProps.history.push('/login');
    }

    if (
      prevState.showPasswordUpdateFields &&
      !nextProps.showPasswordConfirmation &&
      nextProps.lastTransactionState === TRANSACTION_STATE.SUCCESS
    ) {
      nextProps.setLastTransactionState(TRANSACTION_STATE.NO_TRANSACTION);
      return passwordUpdateInitialState;
    } else {
      if (
        nextProps.userInfo &&
        (!prevState.selectedLearningLanguage ||
          !prevState.selectedVoiceType ||
          !prevState.selectedTimezone)
      ) {
        let isLoadingPasswordMode = prevState.isLoadingPasswordMode;
        if (!nextProps.passwordMode && !isLoadingPasswordMode) {
          // ask ego what the rules are about creating passwords in this org
          nextProps.loadPasswordMode({ userId: nextProps.userInfo.gui, resetPasswordId: undefined });
          isLoadingPasswordMode = true;
        }
        // set the things
        return {
          isLoadingPasswordMode: isLoadingPasswordMode,
          selectedLearningLanguage: prevState.selectedLearningLanguage
            ? prevState.selectedLearningLanguage
            : nextProps.userInfo.targetLanguage.language,
          selectedVoiceType: prevState.selectedVoiceType
            ? prevState.selectedVoiceType
            : nextProps.userInfo.preferences && nextProps.userInfo.preferences.voiceType
            ? nextProps.userInfo.preferences.voiceType
            : '',
          selectedTimezone: prevState.selectedTimezone ? prevState.selectedTimezone : nextProps.userInfo.timezone
        };
      }
      if (
        nextProps.showSaveChangesConfirmation &&
        nextProps.showSaveChangesConfirmation !== prevState.showSaveChangesConfirmation
      ) {
        return { showSaveChangesConfirmation: nextProps.showSaveChangesConfirmation };
      }
    }
    return null;
  }

  // this is an optimization so we don't have to translate *everything* every time
  //  the page renders, but will still respond when the ui language changes
  // TODO: this was (mostly - no T&C) copied from RegisterUser.jsx, consider refactoring to a common place
  localizedToLanguage = '';
  localizedVoiceTypes = [];
  localizedTimezones = [];
  installLocalizations = () => {
    if (this.props.lionLoaded && this.props.lionLanguage !== this.localizedToLanguage) {
      this.localizedLearningLanguages = this.props.localizedLearningLanguages();
      this.localizedVoiceTypes = voiceTypes.map((voiceType) => {
        return { value: voiceType.value, label: this.props.lionTranslateString(voiceType.labelKey) };
      });
      this.localizedTimezones = timezones.map((timezoneObj) => {
        return { value: timezoneObj.value, label: this.props.lionTranslateString(timezoneObj.labelKey) };
      });
      this.localizedTimezones.sort((zoneOne, zoneTwo) => {
        if (zoneOne.label > zoneTwo.label) {
          return 1;
        }
        if (zoneOne.label < zoneTwo.label) {
          return -1;
        }
        return 0;
      });

      this.localizedToLanguage = this.props.lionLanguage;
    }
  };

  handleLearningLanguageSelected = (languageObj) => {
    this.setState({ selectedLearningLanguage: languageObj.value });
  };

  handleVoiceTypeSelected = (voicetypeObj) => {
    this.setState({ selectedVoiceType: voicetypeObj.value });
  };

  voiceTypeError = () => {
    if (!this.state.validatingAll) {
      return '';
    }
    return validateUserInfo('voiceType', this.state.selectedVoiceType);
  };

  handleTimezoneSelected = (zoneObj) => {
    this.setState({ selectedTimezone: zoneObj.value });
  };

  timezoneError = () => {
    if (!this.state.validatingAll) {
      return '';
    }
    return validateUserInfo('timezone', this.state.selectedTimezone);
  };

  handleSaveChangesButtonClick = (event) => {
    if (this.state.showPasswordUpdateFields) {
      let allValid = true;
      if (this.oldPasswordError().length > 0) {
        allValid = false;
        this.setState({
          validatingOldPassword: true
        });
      }
      if (this.passwordError().length > 0) {
        allValid = false;
        this.setState({
          validatingPassword: true
        });
      }
      if (this.passwordMatchError().length > 0) {
        allValid = false;
        this.setState({
          validatingPasswordMatch: true
        });
      }
      if (allValid) {
        this.props.processPasswordUpdate(this.state.password, this.state.oldPassword);
      }
    } else if (this.state.showChangeLanguageField) {
      this.props.setUserTargetLanguage(this.state.selectedLearningLanguage);
    } else {
      this.setState({
        validatingAll: true
      });
      // calling forceUpdate() so the state gets squared away
      this.forceUpdate(() => {
        if (this.voiceTypeError() || this.timezoneError()) {
          return;
        }
        const preferencesInfo = {
          preferences: {
            voiceType: this.state.selectedVoiceType
          },
          timezone: this.state.selectedTimezone
        };
        this.props.savePreferences(preferencesInfo);
      });
    }
  };

  handleCancelChangesButtonClick = (event) => {
    if (this.state.showPasswordUpdateFields) {
      this.hideUpdatePassword();
    } else if (this.state.showChangeLanguageField) {
      this.setState({ selectedLearningLanguage: this.props.userInfo.targetLanguage.language });
      this.hideChangeLanguageField();
    } else {
      this.props.cancelPreferences();
    }
  };

  showUpdatePassword = () => {
    this.setState({
      showPasswordUpdateFields: true
    });
  };

  hideUpdatePassword = () => {
    this.props.setLastTransactionState(TRANSACTION_STATE.NO_TRANSACTION);
    this.setState(passwordUpdateInitialState);
  };

  showChangeLanguageField = () => {
    this.setState({
      showChangeLanguageField: true
    });
  };

  hideChangeLanguageField = () => {
    this.props.setLastTransactionState(TRANSACTION_STATE.NO_TRANSACTION);
    this.setState({
      showChangeLanguageField: false
    });
  };

  // the password is validated as soon as the user enters the first character,
  //  and only if there is something in the field.
  //  After the first time they type something in the match, it always validates
  //  even if the field becomes empty - but not the first time if it is empty.
  textInput = (event, whichPasswordPrompt) => {
    if (whichPasswordPrompt === 'old') {
      this.setState({
        validatingOldPassword: false,
        oldPassword: event.target.value
      });
    } else if (whichPasswordPrompt === 'new') {
      if (event.target.value.length > 0) {
        this.setState({
          validatingPassword: true,
          password: event.target.value
        });
      } else {
        this.setState({
          password: event.target.value
        });
      }
    } else {
      if (event.target.value.length > 0) {
        this.setState({
          validatingPasswordMatch: true,
          passwordConfirm: event.target.value
        });
      } else {
        this.setState({
          passwordConfirm: event.target.value
        });
      }
    }
  };

  mapEnterToAction = (event) => {
    if (event.key === 'Enter') {
      this.handleSaveChangesButtonClick();
    }
  };

  oldPasswordError = () => {
    return validateUserInfo('password', this.state.oldPassword);
  };

  passwordError = () => {
    return validateUserInfo('newPassword', this.state.password, '', this.props.passwordMode);
  };

  passwordMatchError = () => {
    return validateUserInfo('newPasswordMatch', this.state.passwordConfirm, this.state.password);
  };

  render = () => {
    if (!this.props.lionLoaded) {
      return null;
    }

    if (!this.props.userInfo) {
      // userInfo is null when rendering during logout
      return <MouseCatcher />;
    }

    if (!this.props.passwordMode) {
      return <MouseCatcher />;
    }

    isRtl = this.props.isInterfaceRtl;

    const isMobile = isMobileDetected;

    // this is for the overall page error display
    let errorDisp = null;
    if (this.props.lastTransactionState === TRANSACTION_STATE.FAIL) {
      // If the server error has a lion key, use it
      let errorKey = 'system_error_internal_service_error_(500)';
      if (this.props.lastTransactionError) {
        if (this.props.lastTransactionError === 'wrong_password') {
          errorKey = 'error_changepassword_wrong_current_password';
        } else {
          errorKey = this.props.lastTransactionError;
        }
      }
      errorDisp = (
        <ErrorDisp data-qa="ErrorDisp" isMobile={isMobile}>
          {this.props.lionTranslateString(errorKey)}
        </ErrorDisp>
      );
    }

    // Prefs save success stuff
    if (this.state.showSaveChangesConfirmation && this.props.lastTransactionState === TRANSACTION_STATE.SUCCESS) {
      errorDisp = (
        <SuccessDisp data-qa="SuccessDisp" isMobile={isMobile}>
          <SuccessMessage>{this.props.lionTranslateString('profile_update_success')}</SuccessMessage>
        </SuccessDisp>
      );
    }

    let preferencesWidgets = null;
    this.installLocalizations();

    let voiceTypeErrorDisp = null;
    if (this.voiceTypeError()) {
      voiceTypeErrorDisp = (
        <FieldErrorDisp data-qa="VoiceTypeError">
          {this.props.lionTranslateString(this.voiceTypeError())}
        </FieldErrorDisp>
      );
    }

    let timezoneErrorDisp = null;
    if (this.timezoneError()) {
      timezoneErrorDisp = (
        <FieldErrorDisp data-qa="TimezoneError">{this.props.lionTranslateString(this.timezoneError())}</FieldErrorDisp>
      );
    }

    let emailDisp = null;
    if (!this.props.userInfo.email.endsWith('@example.com')) {
      emailDisp = (
        <UserEmail data-qa="UserEmail" isMobile={isMobile}>
          {this.props.userInfo.email}
        </UserEmail>
      );
    }

    // Password change success stuff
    if (this.state.showPasswordUpdateFields && this.props.lastTransactionState === TRANSACTION_STATE.SUCCESS) {
      errorDisp = (
        <SuccessDisp data-qa="SuccessDisp" isMobile={isMobile}>
          <SuccessMessage>{this.props.lionTranslateString('profile_password_change_success')}</SuccessMessage>
        </SuccessDisp>
      );
    }

    let successIconUrl = 'url(' + greenCheck + ')';
    const successIconSize = { width: 20, height: 20 };
    let oldValidationMessageBlock = null;
    const oldPasswordHasError = this.state.validatingOldPassword && this.oldPasswordError().length > 0;
    if (oldPasswordHasError) {
      oldValidationMessageBlock = (
        <ValidationMessage data-qa="OldPasswordError">
          {this.props.lionTranslateString(this.oldPasswordError())}
        </ValidationMessage>
      );
    }

    let newValidationMessageBlock = null;
    const newPasswordHasError = this.state.validatingPassword && this.passwordError().length > 0;
    if (newPasswordHasError) {
      newValidationMessageBlock = (
        <ValidationMessage data-qa="PasswordError">
          {this.props.lionTranslateString(this.passwordError())}
        </ValidationMessage>
      );
    }

    let confirmationMessageBlock = null;
    const passwordConfirmtionHasError = this.state.validatingPasswordMatch && this.passwordMatchError().length > 0;
    if (passwordConfirmtionHasError) {
      confirmationMessageBlock = (
        <ValidationMessage data-qa="PasswordMatchError">
          {this.props.lionTranslateString(this.passwordMatchError())}
        </ValidationMessage>
      );
    }

    let oldPasswordSuccessIconUrl = '';
    let oldPasswordSuccessIconSize = { width: 0, height: 0 };
    if (this.state.validatingOldPassword && !oldPasswordHasError) {
      oldPasswordSuccessIconUrl = successIconUrl;
      oldPasswordSuccessIconSize = successIconSize;
    }

    let passwordSuccessIconUrl = '';
    let passwordSuccessIconSize = { width: 0, height: 0 };
    if (this.state.validatingPassword && !newPasswordHasError) {
      passwordSuccessIconUrl = successIconUrl;
      passwordSuccessIconSize = successIconSize;
    }

    let passwordConfirmSuccessIconUrl = '';
    let passwordConfirmSuccessIconSize = { width: 0, height: 0 };
    if (this.state.validatingPasswordMatch && !passwordConfirmtionHasError) {
      passwordConfirmSuccessIconUrl = successIconUrl;
      passwordConfirmSuccessIconSize = successIconSize;
    }

    const localizedOldPasswordPrompt = this.props.lionTranslateString('profile_currentpassword_placeholder');
    const localizedPasswordPrompt = this.props.lionTranslateString('profile_newpassword_placeholder');
    const localizedPasswordConfirmPrompt = this.props.lionTranslateString('profile_repeatnewpassword_label');

    let passwordTooltipButton;
    if (!isMobile) {
      let helpKey = 'profile_password_help_text';
      if (this.props.passwordMode === 'strict') {
        helpKey = 'password_strict_requirements';
      }
      passwordTooltipButton = (
        <PasswordToolTip>
          <HelpButton helpTextKey={helpKey} tipPosition="left" />
        </PasswordToolTip>
      );
    }

    let passwordUpdateFragment;
    if (this.props.userInfo && this.props.userInfo.externalIds && this.props.userInfo.externalIds.sso) {
      // No password for SSO users
      passwordUpdateFragment = null;
    } else {
      if (this.state.showPasswordUpdateFields) {
        passwordUpdateFragment = (
          <PasswordInputContainer>
            <PasswordPromptLabel>
              <LionTranslate lionkey="profile_currentpassword_label" />
            </PasswordPromptLabel>
            {oldValidationMessageBlock}
            <InputAndAlertContainer
              displayError={oldPasswordHasError}
              outsideHeight={widgetHeight}
              marginBottom={10}
              inputSideMargin={boxSidePadding}
            >
              <InputWithIcon
                dataQa="OldPassword"
                inputType="password"
                autoFocus={true}
                placeholder={localizedOldPasswordPrompt}
                tabIndex={1}
                value={this.state.oldPassword}
                onChange={(event) => this.textInput(event, 'old')}
                onKeyPress={this.mapEnterToAction}
                outsideHeight={widgetHeight}
                displayError={oldPasswordHasError}
                specialIconUrl={oldPasswordSuccessIconUrl}
                specialIconSize={oldPasswordSuccessIconSize}
              />
            </InputAndAlertContainer>
            {passwordTooltipButton}
            <PasswordPromptLabel>
              <LionTranslate lionkey="profile_newpassword_label" />
            </PasswordPromptLabel>
            {newValidationMessageBlock}
            <InputAndAlertContainer
              displayError={newPasswordHasError}
              outsideHeight={widgetHeight}
              marginBottom={10}
              inputSideMargin={boxSidePadding}
            >
              <InputWithIcon
                dataQa="NewPassword"
                inputType="password"
                placeholder={localizedPasswordPrompt}
                tabIndex={1}
                value={this.state.password}
                onChange={(event) => this.textInput(event, 'new')}
                onKeyPress={this.mapEnterToAction}
                outsideHeight={widgetHeight}
                displayError={newPasswordHasError}
                specialIconUrl={passwordSuccessIconUrl}
                specialIconSize={passwordSuccessIconSize}
              />
            </InputAndAlertContainer>
            {confirmationMessageBlock}
            <InputAndAlertContainer
              displayError={passwordConfirmtionHasError}
              outsideHeight={widgetHeight}
              marginBottom={10}
              inputSideMargin={boxSidePadding}
            >
              <InputWithIcon
                dataQa="NewPasswordConfirm"
                inputType="password"
                placeholder={localizedPasswordConfirmPrompt}
                tabIndex={2}
                value={this.state.passwordConfirm}
                onChange={(event) => this.textInput(event, 'confirm')}
                onKeyPress={this.mapEnterToAction}
                outsideHeight={widgetHeight}
                displayError={passwordConfirmtionHasError}
                specialIconUrl={passwordConfirmSuccessIconUrl}
                specialIconSize={passwordConfirmSuccessIconSize}
              />
            </InputAndAlertContainer>
          </PasswordInputContainer>
        );
      } else if (!this.state.showChangeLanguageField) {
        passwordUpdateFragment = (
          <React.Fragment>
            <InputWithIcon
              dataQa="Password"
              inputType="password"
              outsideHeight={widgetHeight}
              placeholder="-DUMMY-TEXT-"
              value="-DUMMY-TEXT-"
            />
            <PasswordUpdateLink onClick={() => this.showUpdatePassword()}>
              <LionTranslate lionkey="profile_changepassword_link" />
            </PasswordUpdateLink>
          </React.Fragment>
        );
      }
    }

    let changeLanguageFragment;
    let localizedSelectedLearningLanguageLabel;
    const productRights = this.props.productRights.map((product) => product.productId);
    const showChangeLanguageOption =
      this.props.showlearnerCanChangeL2 &&
      (productRights.includes(catalystProductId) || productRights.includes(foundationProductId));
    const localizedSelectedLearningLanguage = this.localizedLearningLanguages.filter((language) => {
      return language.value === this.state.selectedLearningLanguage;
    })[0];
    if (localizedSelectedLearningLanguage && localizedSelectedLearningLanguage.label) {
      localizedSelectedLearningLanguageLabel = this.props.lionTranslateString(localizedSelectedLearningLanguage.label);
    } else {
      localizedSelectedLearningLanguageLabel = this.props.lionTranslateString('signup_dropdown_select_text');
    }
    if (showChangeLanguageOption && this.state.showChangeLanguageField) {
      changeLanguageFragment = (
        <div style={{ marginTop: 20 }}>
          <FieldLabel data-qa="ChangeLanguageOfStudyLabel">
            <LionTranslate lionkey="profile_change_language_title" />
          </FieldLabel>
          <MenuContainer marginBottom={10} marginTop={5}>
            <RSDropdown
              dataQa="ChangeLanguageMenu"
              buttonText={localizedSelectedLearningLanguageLabel}
              itemsList={this.localizedLearningLanguages}
              itemDisplayProperty="label"
              itemKeyProperty="value"
              onSelectionHandler={this.handleLearningLanguageSelected}
              selectedKey={this.state.selectedLearningLanguage}
              menuTabIndex={4}
              isRtl={isRtl}
              menuStyle={menuStyle}
            />
          </MenuContainer>
          <FieldErrorDisp data-qa="ChangeLanguagWarning">
            <LionTranslate lionkey="profile_change_language_warning" />
          </FieldErrorDisp>
        </div>
      );
    } else if (showChangeLanguageOption && !this.state.showPasswordUpdateFields) {
      changeLanguageFragment = (
        <div style={{ marginTop: 45 }}>
          <DisabledMenuButton disabled={true} marginBottom={10}>
            <DisabledMenuButtonArrow />
            <DisabledMenuButtonLabel>{localizedSelectedLearningLanguageLabel}</DisabledMenuButtonLabel>
          </DisabledMenuButton>
          <ChangeLanguageLink onClick={() => this.showChangeLanguageField()}>
            <LionTranslate lionkey="profile_change_language_button" />
          </ChangeLanguageLink>
        </div>
      );
    }

    let rightColumnFragment = null;
    if (this.state.showPasswordUpdateFields || this.state.showChangeLanguageField) {
      let localizedSelectedVoiceTypeLabel;
      const localizedSelectedVoiceType = this.localizedVoiceTypes.filter((voiceType) => {
        return voiceType.value === this.state.selectedVoiceType;
      })[0];
      if (localizedSelectedVoiceType && localizedSelectedVoiceType.label) {
        localizedSelectedVoiceTypeLabel = this.props.lionTranslateString(localizedSelectedVoiceType.label);
      } else {
        localizedSelectedVoiceTypeLabel = this.props.lionTranslateString('signup_dropdown_select_text');
      }
      let localizedSelectedTimezoneLabel;
      const localizedSelectedTimezone = this.localizedTimezones.filter((timezone) => {
        return timezone.value === this.state.selectedTimezone;
      })[0];
      if (localizedSelectedTimezone && localizedSelectedTimezone.label) {
        localizedSelectedTimezoneLabel = this.props.lionTranslateString(localizedSelectedTimezone.label);
      } else {
        localizedSelectedTimezoneLabel = this.props.lionTranslateString('signup_dropdown_select_text');
      }
      rightColumnFragment = (
        <RightColumn isMobile={isMobile}>
          <div style={{ height: '10px' }} />
          <FieldLabel data-qa="VoiceTypeDropdown">{this.props.lionTranslateString('signup_voice_type')}</FieldLabel>
          {!isMobile ? <DisabledHelpButton /> : null}
          <DisabledMenuButton disabled={true}>
            <DisabledMenuButtonArrow />
            <DisabledMenuButtonLabel>{localizedSelectedVoiceTypeLabel}</DisabledMenuButtonLabel>
          </DisabledMenuButton>

          <FieldLabel data-qa="TimeZoneDropdown">
            {this.props.lionTranslateString('signup_time_zone_selection')}
          </FieldLabel>
          {!isMobile ? <DisabledHelpButton /> : null}
          <DisabledMenuButton disabled={true}>
            <DisabledMenuButtonArrow />
            <DisabledMenuButtonLabel>{localizedSelectedTimezoneLabel}</DisabledMenuButtonLabel>
          </DisabledMenuButton>
        </RightColumn>
      );
    } else {
      rightColumnFragment = (
        <RightColumn isMobile={isMobile}>
          <div style={{ height: '10px' }} />
          <FieldLabel>{this.props.lionTranslateString('signup_voice_type')}</FieldLabel>
          {!isMobile ? (
            <HelpButton data-qa="VoiceTypeHelpButton" helpTextKey="signup_voice_type_help_text" tipPosition="top" />
          ) : null}
          {voiceTypeErrorDisp}
          <MenuContainer>
            <RSDropdown
              dataQa="VoiceTypeMenu"
              buttonText={this.props.lionTranslateString('signup_dropdown_select_text')}
              itemsList={this.localizedVoiceTypes}
              itemDisplayProperty="label"
              itemKeyProperty="value"
              onSelectionHandler={this.handleVoiceTypeSelected}
              selectedKey={this.state.selectedVoiceType}
              menuTabIndex={4}
              isRtl={isRtl}
              menuStyle={menuStyle}
            />
          </MenuContainer>

          <FieldLabel>{this.props.lionTranslateString('signup_time_zone_selection')}</FieldLabel>
          {!isMobile ? (
            <HelpButton data-qa="TimezoneHelpButton" helpTextKey="signup_time_zone_help_text" tipPosition="top" />
          ) : null}
          {timezoneErrorDisp}
          <MenuContainer>
            <RSDropdown
              dataQa="TimeZoneMenu"
              buttonText={this.props.lionTranslateString('signup_dropdown_select_text')}
              itemsList={this.localizedTimezones}
              itemDisplayProperty="label"
              itemKeyProperty="value"
              onSelectionHandler={this.handleTimezoneSelected}
              selectedKey={this.state.selectedTimezone}
              menuTabIndex={5}
              isRtl={isRtl}
              menuStyle={menuStyle}
            />
          </MenuContainer>
        </RightColumn>
      );
    }

    let saveButtonKey = 'profile_button_savechanges';
    if (this.state.showPasswordUpdateFields) {
      saveButtonKey = 'profile_changepassword_link';
    } else if (this.state.showChangeLanguageField) {
      saveButtonKey = 'profile_change_language_button';
    }

    preferencesWidgets = (
      <React.Fragment>
        <TopContainer data-qa="TopContainer" isMobile={isMobile}>
          <UserName data-qa="UserName" isMobile={isMobile}>
            {this.props.userInfo.firstName + ' ' + this.props.userInfo.lastName}
          </UserName>
        </TopContainer>
        <MiddleContainer>
          <LeftColumn isMobile={isMobile}>
            {emailDisp}
            {passwordUpdateFragment}
            {changeLanguageFragment}
          </LeftColumn>
          {rightColumnFragment}
        </MiddleContainer>
        <BottomContainer data-qa="BottomContainer" isMobile={isMobile}>
          <SaveChangesButton
            data-qa="PreferencesSaveChangesButton"
            onClick={() => this.handleSaveChangesButtonClick()}
            isMobile={isMobile}
          >
            <LionTranslate lionkey={saveButtonKey} />
          </SaveChangesButton>
          <CancelChangesButton
            data-qa="PreferencesCancelChangesButton"
            onClick={() => this.handleCancelChangesButtonClick()}
            isMobile={isMobile}
          >
            <LionTranslate lionkey="forgotpassword_cancel_link" />
          </CancelChangesButton>
        </BottomContainer>
      </React.Fragment>
    );
    return (
      <PreferencesDiv data-qa="Preferences" isMobile={isMobile}>
        <PreferencesBox isMobile={isMobile}>
          {errorDisp}
          {preferencesWidgets}
        </PreferencesBox>
      </PreferencesDiv>
    );
  };
}

const mapStateToProps = (state, ownprops) => ({
  isAppInitialized: appSelectors.isAppInitialized(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionLanguage: lionSelectors.getLionLanguage(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  },
  localizedLearningLanguages: () => {
    return getLearnerSelectLearningLanguages(state);
  },
  userInfo: authSelectors.userInfo(state),
  productRights: authSelectors.productRights(state),
  loginStatus: authSelectors.loginStatus(state),
  lastTransactionState: appSelectors.lastTransactionState(state),
  showPasswordConfirmation: preferencesSelectors.showPasswordConfirmation(state),
  showSaveChangesConfirmation: preferencesSelectors.showSaveChangesConfirmation(state),
  lastTransactionError: appSelectors.lastTransactionError(state),
  passwordMode: passwordChangeSelectors.getPasswordMode(state),
  showlearnerCanChangeL2: preferencesSelectors.showlearnerCanChangeL2(state)
});

const wrapActions = {
  logoutUser: appActions.logoutUser,
  processPasswordUpdate: preferencesActions.processPasswordUpdate,
  setLastTransactionState: appActions.setLastTransactionState,
  cancelPreferences: preferencesActions.cancelPreferences,
  savePreferences: preferencesActions.savePreferences,
  loadPasswordMode: passwordChangeActions.loadPasswordMode,
  setUserTargetLanguage: appActions.setUserTargetLanguage,
  getLearnerCanChangeL2: preferencesActions.getLearnerCanChangeL2
};

export const PreferencesContainer = connect(
  mapStateToProps,
  wrapActions
)(withWindowDimensions(Preferences));



// WEBPACK FOOTER //
// ./src/modules/preferences/components/Preferences.jsx